import { generateUUID } from "shared/lib/generateUUID"
import { ProductPositionAddonTypename } from "shared/types/Project"
import {
  ProductConfigurationResponse,
  ProductPositionAddon
} from "shared/types/__generated__/graphql"

import { getProductType } from "entities/products/lib/getProductType"

export function getProductPositionAddonsFromConfiguration(
  configuration: ProductConfigurationResponse | null | undefined
): ProductPositionAddon[] {
  if (!configuration || !configuration.variantKey) {
    return []
  }
  return (
    configuration.accessories?.map(addon => ({
      id: generateUUID(),
      variantKey: addon,
      parentProductType: getProductType(configuration.variantKey as string),
      label: getProductType(addon),
      __typename: ProductPositionAddonTypename
    })) || []
  )
}
